import React from "react";
import Spinner from "../Spinner/Spinner";
import "./LoadingPanel.css";

interface LoadingPanelProps {
  title: string;
  subtitle?: string;
  className?: string;
  /** Tall enough to keep the footer below the visible viewport. */
  fill?: boolean;
}

export default function LoadingPanel({
  title,
  subtitle,
  className = "",
  fill = false,
}: LoadingPanelProps) {
  return (
    <div
      className={`loading-panel flex flex-col items-center justify-center py-20 px-6 text-center ${
        fill ? "loading-panel--fill" : ""
      } ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="loading-panel__spinner-ring mb-6" aria-hidden="true" />
      <Spinner />
      <p className="loading-panel__title mt-6 text-lg font-medium text-slate-800">
        {title}
        <span className="loading-panel__dots" aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </p>
      {subtitle && (
        <p className="mt-2 text-sm text-slate-500 max-w-sm">{subtitle}</p>
      )}
    </div>
  );
}
